export interface User {
    id?: string,
    name: string,
    email: string,
    contactNo: string,
    shippingDetails: ShippingDetails,
    location: Location,
    profilePicture: string,
    status: Status,
    role: Role,
    emailVerified:boolean,
    createdAt: string,
    updatedAt: string
}

export interface ShippingDetails {
    fullName:string,
    address: string,
    country: string;
    province: string,
    city: string,
    postalCode: string,
    contactNo: string
}

export interface Location {
    longitude: number,
    latitude: number
}

export enum Status {
    ACTIVE = 'Active',
    INACTIVE = 'Inactive',
    DELETED = 'Deleted'
}

export enum Role {
    CUSTOMER = 'Customer',
    ADMIN='Admin'
}